import { Company } from 'Companies/Types/types'

export type CompanyState = {
  company: Company
  loading: boolean
  error: string
}

const initialState: CompanyState = {
  company: {
    _id: '',
    name: '',
    procore: {},
    features: [],
    brokerCode: '',
    disabled: false,
    delete: false
  },
  loading: true,
  error: ''
}

export default initialState
